var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import './PrimaryButton.scss';
var defaultProps = {
    className: 'w-[128px] h-[40px]',
    light: false,
    disabled: false,
    aria: 'Go',
    children: _jsx("span", { children: "Default" }, void 0),
};
var lightClasses = 'bg-white active:bg-[#8bd3e6] text-[#005f9e]';
var darkClasses = 'bg-[#005f9e] active:bg-[#0074bd] text-white';
var disabledClasses = 'disabled:bg-[#d8dcdb] disabled:text-[#767676]';
var textClasses = 'text-[16px] font-medium leading-normal';
export var PrimaryButton = function (_a) {
    var className = _a.className, light = _a.light, disabled = _a.disabled, aria = _a.aria, onClick = _a.onClick, children = _a.children;
    return (_jsx("button", __assign({ className: "button flex items-center justify-center " + (light ? lightClasses : darkClasses) + " " + disabledClasses + " " + textClasses + " " + (className || ''), disabled: disabled, "aria-label": aria, "data-light": light, onClick: onClick }, { children: children }), void 0));
};
PrimaryButton.defaultProps = defaultProps;
